import { jsx } from 'react/jsx-runtime';

const ModalCard = ({ children }) => (jsx("div", Object.assign({ className: 'modal-card' }, { children: children })));

export { ModalCard };
